import { render, staticRenderFns } from "./Progressbar.vue?vue&type=template&id=86ddecc6&scoped=true"
import script from "./Progressbar.vue?vue&type=script&lang=js"
export * from "./Progressbar.vue?vue&type=script&lang=js"
import style0 from "./Progressbar.vue?vue&type=style&index=0&id=86ddecc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ddecc6",
  null
  
)

export default component.exports